// SignatureImage.js

import React from 'react';
import { styled } from '@mui/material/styles';

// Styled component for the image
const StyledImage = styled('img')({
  maxWidth: '100%', // Ensure the image doesn't exceed its natural size
  maxHeight: '100%',
  display: 'block',
});

const SignatureImage = ({ imageData }) => {
  return (
    <StyledImage src={imageData} alt="Signature" style={{width:"10%"}}/>
  );
};

export default SignatureImage;
